module.exports = __webpack_public_path__ + "img/QUEL_logo_watermark.51f8f5fb.png";